import Loader from "../../../../../../../shared/Loader/Loader"
import { Modal, ModalBody } from "react-bootstrap"

const AIDiscardTranscriptModal = (props) => {
    const { confimarionPopup, onClose, discardChanges, generatedNoteConfirmation, ActionFuntion } = { ...props }
    return (
        <Modal show={confimarionPopup} onHide={onClose} backdrop="static" keyboard={false} centered dialogClassName="delete-modal hk-modal-v1 ar_delte_modal">
            {/* {isLoading ? <Loader /> : null} */}
            <ModalBody>
                <div className='d-flex justify-content-between delete-header align-items-center mb-12 p-0'>
                    <p className="heading dark-clr fs-14">
                        {generatedNoteConfirmation ? 'Apply Note Before Closing?' : 'Generate Note Before Closing?'}
                    </p>
                    <i className='icon-x-cros fs-20 dark-clr' onClick={onClose}></i>
                </div>
                <div className='undo-body p-0'>
                    <div className='ar-alert d-flex mb-0'>
                        <i className='icon-alert mt-1'></i>
                        <div>
                            <p className='text ms-1'>
                                {generatedNoteConfirmation ? 'Your AI-generated note has not been applied to the encounter. If you close now, the generated note will be discarded.' :
                                    'Your transcription is ready, but the note has not been generated. If you close now, the transcription and pending note will be discarded.'
                                }

                            </p>
                        </div>
                    </div>
                </div>
            </ModalBody>

            <div className="d-flex align-items-center pb-15 px-10 pt-2 br-top-1 za_br_light justify-content-end gap-2 ar_footer">
                <button className='btn btn-outline  px-10 h-100 dark-clr' onClick={onClose} >Cancel</button>
                <button className='btn btn-danger px-10 h-100' onClick={discardChanges}>Discard</button>
                <button className='btn btn-danger px-10 h-100' onClick={ActionFuntion}>
                    {generatedNoteConfirmation ? 'Add to Encounter' : 'Generate Note '}
                </button>
            </div>
        </Modal>
    )
}

export default AIDiscardTranscriptModal